import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

export const BookingExtraSchema = z.object({
    id: z.string().uuid(),
    booking_room_id: z.string().uuid(),
    inventory_id: z.string().uuid().optional().nullable(),
    item_name: z.string(),
    // Rincian item + pajak dari POS (teks siap cetak, multi-baris).
    description: z.string().nullable().optional(),
    qty: z.number(),
    amount: z.string(), // API typically returns amount as string
    date: z.string(),
    category: z.string().nullable().optional(),
    // 'pos' = dibuat dari POS dan terkunci dari perubahan manual di PMS.
    source: z.string().nullable().optional(),
    created_at: z.string(),
    updated_at: z.string(),
});

export const BookingExtraResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(BookingExtraSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type BookingExtraResponse = z.infer<typeof BookingExtraResponseSchema>;
export type BookingExtraData = z.infer<typeof BookingExtraSchema>;
